import { ENDPOINTS } from './endpoints'

import { TOKEN_KEY } from '../storage/constants'
import { getDataFromStorage } from '../storage/storageRepository'

import type { SendToEmployeeEmail } from './types'

const parseResponse = (xhr: XMLHttpRequest) => {
  try {
    return JSON.parse(xhr.responseText)
  } catch (_error) {
    return { response: xhr.responseText }
  }
}

export const mountUrl = (url: string) => `${process.env.API_BASE_URL}${url}`
export const get = <T extends unknown>(url: string) =>
  request<T>({ url, method: 'GET' })
export const put = <T extends unknown>(url: string, data: unknown) =>
  request<T>({ url, method: 'PUT', data })

export const post = <T extends unknown>(
  url: string,
  data: unknown,
  modifyXHR?: (xhr: XMLHttpRequest) => void
) =>
  new Promise<T>((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', url)
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')

    if (modifyXHR) {
      modifyXHR(xhr)
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            resolve(parseResponse(xhr) as T)
          } catch (_error) {
            resolve({} as T)
          }
        } else {
          try {
            reject(parseResponse(xhr))
          } catch (_error) {
            reject({ error: 'Request failed' })
          }
        }
      }
    }
    xhr.send(JSON.stringify(data))
  })

const request = <T extends unknown>(opts: {
  method: string
  url: string
  data?: unknown
  token?: string
  status?: number
}) =>
  new Promise<T>((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(opts.method, opts.url)
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')

    const token = opts.token || getDataFromStorage(TOKEN_KEY)
    if (token) {
      xhr.setRequestHeader('Authorization', `Bearer ${token}`)
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (
          Math.floor(xhr.status / 100) === 5 ||
          Math.floor(xhr.status / 100) === 4
        ) {
          reject(parseResponse(xhr))
          return
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText ? parseResponse(xhr) : ({} as T))
          return
        }
        reject(parseResponse(xhr))
      }
    }

    if (opts.data) {
      xhr.send(JSON.stringify(opts.data))
    } else {
      xhr.send()
    }
  })

export const sendEmailToEmployee = async (
  horId: Number,
  data: SendToEmployeeEmail
) =>
  put<any>(
    `${process.env.API_BASE_URL}${ENDPOINTS.SEND_TO_EMPLOYEE(horId)}`,
    data
  )
